import { ApiError } from '../../lib/api';
import type { MediaKitAsset } from '../../lib/api/operatorConsole';

export class ArchiveTimeoutError extends Error {
  constructor() {
    super('archive_timeout');
    this.name = 'ArchiveTimeoutError';
  }
}

export const ARCHIVE_FAILED_MESSAGE = 'We couldn’t build the ZIP.';

export function errorText(err: unknown): string {
  return err instanceof Error ? err.message : 'Unknown error';
}

/** 404 = the card left the pack's window, or the pack art was replaced. */
export function assetErrorMessage(err: unknown, kind: MediaKitAsset['kind']): string {
  if (err instanceof ApiError && err.status === 404) {
    return kind === 'pack_art'
      ? 'This pack art has changed — refresh the page.'
      : 'This card is no longer in the pack — refresh the page.';
  }
  return `Download failed: ${errorText(err)}`;
}

export function archiveErrorMessage(err: unknown): string {
  if (err instanceof ArchiveTimeoutError) {
    return 'The ZIP is taking too long to prepare. Try again in a few minutes.';
  }
  if (err instanceof ApiError && err.status === 429) {
    return 'Too many ZIP requests — wait a minute and try again.';
  }
  if (err instanceof ApiError && err.status === 404) {
    return 'This pack is no longer available — refresh the page.';
  }
  return `Couldn’t prepare the ZIP: ${errorText(err)}`;
}
